var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFpp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 0L7 1.68366L0 9.30073L0.677419 16.0968L2.10677 18H10.2358L13.1148 14.8083L14 3.80415L12.7197 0Z",
    fill: "url(#paint0_linear_18631_57304)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 9.30078L0.677419 16.0969L2.10677 18L4.25645 14.2091L0 9.30078Z",
    fill: "url(#paint1_linear_18631_57304)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.25905 14.2091L2.10938 18.0001H10.2384L13.1174 14.8084L10.9768 7.84326L4.25905 14.2091Z",
    fill: "url(#paint2_linear_18631_57304)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.722 0L10.9766 7.84317L13.1172 14.8083L14.0024 3.80415L12.722 0Z",
    fill: "url(#paint3_linear_18631_57304)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7187 0L7.60869 2.07659L3.39062 5.61073L6.99901 1.68366L12.7187 0Z",
    fill: "url(#paint4_linear_18631_57304)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 18L4.25905 14.209L3.49808 16.3163L2.99002 17.0978L2.89744 18H2.10938Z",
    fill: "#688986"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9766 7.84326L12.8056 13.7942L12.3427 11.643L12.0491 10.9845L11.7014 9.37546L10.9766 7.84326Z",
    fill: "#688986"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M8.8733 9.83616L5.27394 3.5625L2.50781 6.57421L6.89072 11.7152L7.66297 17.9998H9.77201L8.8733 9.83616Z",
    fill: "url(#paint5_linear_18631_57304)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M13.6142 8.58075L11.8078 4.09831L9.68521 0.893433L6.99811 1.68368L6.43359 2.29831L11.2297 6.69295L13.3275 12.1303L13.6142 8.58075Z",
    fill: "url(#paint6_linear_18631_57304)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7216 0L11.8906 0.338049L12.4393 1.27317L14.0019 3.80415L12.7216 0Z",
    fill: "url(#paint7_linear_18631_57304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18631_57304",
    x1: 4.83226,
    y1: -0.656342,
    x2: 9.70038,
    y2: 21.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#048529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18631_57304",
    x1: 3.01452,
    y1: 18.2174,
    x2: 1.38371,
    y2: 8.54331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B9673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18631_57304",
    x1: 3.6426,
    y1: -0.388446,
    x2: 8.51072,
    y2: 21.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18631_57304",
    x1: 11.0985,
    y1: 12.4902,
    x2: 15.3918,
    y2: -0.20704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B9673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18631_57304",
    x1: 4.92159,
    y1: 6.18805,
    x2: 10.4453,
    y2: -0.139913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FF87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18631_57304",
    x1: 10.9801,
    y1: 7.42152,
    x2: 4.9459,
    y2: 13.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18631_57304",
    x1: 12.6342,
    y1: 3.22685,
    x2: 9.37767,
    y2: 8.21379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18631_57304",
    x1: 13.5435,
    y1: 3.97537,
    x2: 12.4372,
    y2: 0.243765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FF87"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpp);
export default __webpack_public_path__ + "static/media/FPP.9492b4f40b71ad47fe57835950c20d18.svg";
export { ForwardRef as ReactComponent };